"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFakeAdapter = void 0;
const BaseBotApiAdapter_1 = __importDefault(require("./BaseBotApiAdapter"));
const BaseExchangeAPIAdapterImpl_1 = __importDefault(require("../../localLogic/BaseExchangeAPIAdapterImpl"));
const OrderDescUtils_1 = require("../MarketTradeDesc/OrderDescUtils");
class FakeCustomAPIAdapterImpl extends BaseExchangeAPIAdapterImpl_1.default {
    constructor(apiKey) {
        super(apiKey);
    }
}
class FakeBotAPIAdapterImpl extends BaseBotApiAdapter_1.default {
    constructor(apiKey) {
        super(apiKey);
    }
}
function getFakeAdapter(apiKey) {
    if ((0, OrderDescUtils_1.isBotTradeSupported)(apiKey.market)) {
        return new FakeBotAPIAdapterImpl(apiKey);
    }
    else {
        return new FakeCustomAPIAdapterImpl(apiKey);
    }
}
exports.getFakeAdapter = getFakeAdapter;
